import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function BillingContent() {
  const { t } = useTranslation('billing');

  return (
    <div>
      <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">{t('title')}</h2>
      <div className="bg-surface-card-light dark:bg-surface-card-dark p-6 rounded-lg shadow">
        <p className="text-slate-600 dark:text-slate-300">{t('description')}</p>
        <p className="text-sm text-text-muted-light dark:text-text-muted-dark mt-2">
          {t('manageInfo')}
        </p>
        <div className="mt-4 flex flex-col items-start gap-3 rounded-md bg-state-info-bg-light p-4 dark:bg-state-info-bg-dark sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-state-info-light dark:text-state-info-dark">
            <strong>{t('note')}:</strong> {t('fullBillingNote')}
          </p>
          <Link
            to="/billing"
            className="inline-flex min-h-11 shrink-0 items-center justify-center rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-on-accent-light transition-colors hover:bg-brand-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:bg-brand-400 dark:text-on-accent-dark dark:hover:bg-brand-300"
          >
            {t('openBillingPage')}
          </Link>
        </div>
      </div>
    </div>
  );
}
